<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Nos Equipes" />
            <LesEquipes />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import LesEquipes from './LesEquipes.vue'


export default {
    name: 'EquipesPage',
    components: {
        NavBar,
        PageTitle,
        LesEquipes,
        FooterComp,
    }
}
</script>